(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureModifierDialogController', ProcedureModifierDialogController);

    ProcedureModifierDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProcedureModifier', 'Procedure', 'Modifier'];

    function ProcedureModifierDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProcedureModifier, Procedure, Modifier) {
        var vm = this;

        vm.procedureModifier = entity;
        vm.clear = clear;
        vm.save = save;
        vm.procedures = Procedure.query();
        vm.modifiers = Modifier.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.procedureModifier.id !== null) {
                ProcedureModifier.update(vm.procedureModifier, onSaveSuccess, onSaveError);
            } else {
                ProcedureModifier.save(vm.procedureModifier, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:procedureModifierUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
